import { render, staticRenderFns } from "./CompromisosReunion.vue?vue&type=template&id=644f4fee&scoped=true"
import script from "./CompromisosReunion.vue?vue&type=script&lang=js"
export * from "./CompromisosReunion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644f4fee",
  null
  
)

export default component.exports